import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { ApiService } from 'src/app/Services/api.service';
import { FileUploadService } from 'src/app/Services/file-upload.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';

@Component({
  selector: 'g10-edit-users',
  templateUrl: './edit-users.component.html',
  styleUrls: ['./edit-users.component.css']
})
export class EditUsersComponent implements OnInit {

  submitted = false;
  public userID;

  matFormSize = '13px'
  usersForm: FormGroup;
 public userIDInformation=[];
  public updateValues=[];
  formSubmit:boolean=false;
  selectedBranch: any[] = []
  public branchInformation: any=[];
  shiftInformation: any = [];
  public showBranch:boolean = false;
  public branchUpdate:boolean=false;
  public isActive_selected:any;

  mail

  public headers:any=[];
  public tableData:any={};
  public userRestrictionData:any={};
  constructor(
    public fb: FormBuilder,
    public api: ApiService,
    public route: ActivatedRoute,
    public swal: SweetAlert,
    public storage: StorageService,
    public router: Router,
    public file: FileUploadService
  ) {
    this.route.paramMap.subscribe((params: any) => {
      this.userID = params.params.userId;
      // console.log('params',params)
    });
  }

  ngOnInit(): void {
    this.addUsersFormLoad();
    setTimeout(()=> this.getUserData() ,500);
    this.getBranchList();
    this.getUserRestictionList();
  }


  // branch details
  getBranchList() {
    this.showBranch = false;

    const obj = {
      orgID: this.storage.get('userInfo').orgID
    };
    this.api.transportManagerBranchList(obj).then((res: any) => {
      if (res.status == 'success') {
        if(res.data && res.data.length>0){
          res.data.filter((e)=>{
            let option={name:e.branchName,value:e.branchID};
            this.branchInformation.push(option);
          });
        }
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  getUserRestictionList(){
    //api call to get user rest list
    let loggedUser = this.storage.get('userInfo');
    const obj = {
      orgID: loggedUser.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
        let selectedUser=res.data['userInfo'].filter(e=> e.userID==this.userID);
        loggedUser['fieldMap']=selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: loggedUser });
        let user = loggedUser;
        if(user && user['fieldMap']){
          this.userRestrictionData=user['fieldMap'];
        }else{
          this.userRestrictionData={
            "Dashboard": {
                "name": "Dashboard",
                "checked":true,
                "menu1": {
                  "Vehicle Information": {
                      "name": "Vehicle Information",
                      "checked":true
                  },
                  "Route Information": {
                      "name": "Route Information",
                      "checked":true
                  },
                  "Roster": {
                      "name": "Roster",
                      "checked":true,
                      "menu2": {
                        "Map": {
                          "name": "Map",
                          "checked":true,
                        },
                        "Reports": {
                            "name": "Reports",
                            "checked":true,
                            "menu3": {
                              "Planned Trips": {
                                "name": "Planned Trips",
                                "checked":true,
                              },
                              "Trip Logs": {
                                  "name": "Trip Logs",
                                  "checked":true,
                              }
                            }
                        },
                        "Dispatch Viewer": {
                            "name": "Dispatch Viewer",
                            "checked":true,
                        },
                        "Roster Summary": {
                          "name": "Roster Summary",
                          "checked":true,
                        }
                      }
                  }
              }
            },
            "SOS Panel": {
              "name": "SOS Panel",
              "checked":true,
            },
            "Request": {
              "name": "Request",
              "checked":true
            },
            "Route / Rostering": {
                "name": "Route / Rostering",
                "checked":true,
                "menu1": {
                    "Activities": {
                      "name": "Activities",
                      "checked":true,
                    },
                    "Manage": {
                      "name": "Manage",
                      "checked":true,
                      "menu2": {
                        "Configuration": {
                          "name": "Configuration",
                          "checked":true,
                        },
                        "Roster":{
                          "name": "Roster",
                          "checked":true,
                        }
                      }
                    },
                    "Regular": {
                        "name": "Regular",
                        "checked":true,
                    },
                    "Occasional": {
                        "name": "Occasional",
                        "checked":true,
                    },
                    "Open Booking": {
                        "name": "Open Booking",
                        "checked":true,
                    }
                }
            },
            "Reports": {
              "name": "Reports",
              "checked":true,
              "menu1": {
                  "SOS Report": {
                      "name": "SOS Report",
                      "checked":true,
                  },
                  "Over Speed Report": {
                      "name": "Over Speed Report",
                      "checked":true,
                  },
                  "Movement Report": {
                      "name": "Movement Report",
                      "checked":true,
                  },
                  "Halt Report": {
                      "name": "Halt Report",
                      "checked":true,
                  },
                  "Productivity Report on Trip": {
                      "name": "Productivity Report on Trip",
                      "checked":true,
                  },
                  "Offline Report": {
                      "name": "Offline Report",
                      "checked":true,
                  },
                  "Employee Booking Reports": {
                      "name": "Employee Booking Reports",
                      "checked":true,
                  },
                  "App Usage Report": {
                      "name": "App Usage Report",
                      "checked":true,
                  },
                  "Safe Drop Report": {
                      "name": "Safe Drop Report",
                      "checked":true,
                  },
                  "Attendance": {
                      "name": "Attendance",
                      "checked":true,
                  },
                  "Trip Report": {
                    "name": "Trip Report",
                    "checked":true,
                  },
                  "Complaint Ratings": {
                      "name": "Complaint Ratings",
                      "checked":true,
                  },
                  "Head Counts": {
                    "name": "Head Counts",
                    "checked":true,
                  },
                  "Geo Entry Exit": {
                    "name": "Geo Entry Exit",
                    "checked":true,
                  },
                  "Vehicle Audit Report": {
                      "name": "Vehicle Audit Report",
                      "checked":true,
                  },
                  "Vehicle Arriving Time": {
                      "name": "Vehicle Arriving Time",
                      "checked":true,
                  },
                  "Employee Boarding History": {
                      "name": "Employee Boarding History",
                      "checked":true,
                  },
                  "Seat Occupancy Report": {
                      "name": "Seat Occupancy Report",
                      "checked":true,
                  },
                  "Route Violation": {
                      "name": "Route Violation",
                      "checked":true,
                  },
                  "GPS Failure": {
                      "name": "GPS Failure",
                      "checked":true,
                  }
              }
            },
            "Information": {
              "name": "Information",
              "checked":true,
              "menu1": {
                  "Transport Vendors": {
                      "name": "Transport Vendors",
                      "checked":true,
                  },
                  "Organization": {
                      "name": "Organization",
                      "checked":true,
                      "menu2":{
                        "Branch": {
                          "name": "Branch",
                          "checked":true,
                        },
                        "Shift Management": {
                            "name": "Shift Management",
                            "checked":true,
                        },
                        "Employees": {
                          "name": "Employees",
                          "checked":true,
                        },
                        "Guest": {
                            "name": "Guest",
                            "checked":true,
                        },
                        "Parking": {
                          "name": "Parking",
                          "checked":true,
                        },
                        "Notifications": {
                          "name": "Notifications",
                          "checked":true,
                        },
                        "Holidays": {
                            "name": "Holidays",
                            "checked":true,
                        },
                        "Escort": {
                            "name": "Escort",
                            "checked":true,
                        },
                        "Location": {
                            "name": "Location",
                            "checked":true,
                        },
                        "Global Settings": {
                            "name": "Global Settings",
                            "checked":true,
                        },
                        "Users": {
                            "name": "Users",
                            "checked":true,
                        }
                      }
                  },
                  "Account": {
                      "name": "Account",
                      "checked":true,
                  }
              }
            },
            "Support Desk": {
              "name": "Support Desk",
              "checked":true,
              "menu1": {
                  "Announcement": {
                      "name": "Announcement",
                      "checked":true,
                  },
                  "Complaints": {
                      "name": "Complaints",
                      "checked":true,
                  },
                  "Feedback": {
                      "name": "Feedback",
                      "checked":true,
                  },
                  "Ticket": {
                      "name": "Ticket",
                      "checked":true,
                  }
              }
            }
          }
        }
        this.userRestrictionData=JSON.parse(JSON.stringify(this.userRestrictionData));
        this.tableData=JSON.parse(JSON.stringify(this.userRestrictionData));
        this.headers=Object.keys(this.tableData);
    }).catch((err) => {
        console.log(err);
    });
  }
  onChangeBranch(val) {
    this.selectedBranch = []
    this.shiftInformation.forEach((element, i) => {
      if (element.branch == val) {
        this.selectedBranch.push(element)
      }
    });
    if (this.branchUpdate) this.fieldChange(val,'branch','branch');

  }


  // getBranchList() {
  //   this.showBranch = false;
  //   const obj = {
  //     orgID: this.storage.get('userInfo').orgID
  //   };
  //   this.api.transportManagerBranchList(obj).then((res: any) => {
  //     if (res.status == 'success') {
  //       this.branchInformation = res.data;
  //       this.addBranchOptions();
  //     }
  //   }).catch((err) => {
  //     this.showBranch = true
  //     console.log(err);
  //   });
  // }
  // addBranchOptions(){
  //   if(this.branchInformation && this.branchInformation.length>0){
  //     this.branchInformation.filter((e)=>{
  //       let option={name:e.branchName,value:e.branchID};
  //       this.fieldOptions[0].branch.push(option);
  //     });
  //   }
  //   this.showBranch = true;
  // }


  addUsersFormLoad() {
    this.usersForm = new FormGroup({
      name: new FormControl('', [Validators.required]),
      userEmail: new FormControl('', [Validators.required, Validators.email]),
      designation: new FormControl('', [Validators.required]),
      contactNumber: new FormControl('', [Validators.required, Validators.pattern('[0-9]\\d{9}')]),
      isActive: new FormControl('',[Validators.required]),
      branch: new FormControl('', [Validators.required]),

    });
  }

  getUserData() {
    const obj = {
      userID: this.userID
    };
    this.api.transportManagerUserList(obj).then((res: any) => {
      // console.log(obj)
      if (res.status == 'success') {
        const data = res.data[0];
        this.userIDInformation=res.data[0]
        this.setValueUserForm( this.userIDInformation);
      }
    }).catch((err) => {
      console.log(err);
    });
  }
  setValueUserForm(data) {
    // console.log(data);
    this.isActive_selected = ''+data['isActive']; //===1?'Active':'Inactive';
    this.usersForm.patchValue({
      name: data.name,
      userEmail: data.userEmail,
      designation: data.designation,
      contactNumber: data.contactNumber,
      isActive: data.isActive,
      branch: data.branch,
    });
    this.mail = data.userEmail
    this.onChangeBranch(data.branch);
    this.branchUpdate = true;
  }
  

 
  


  /* update unique field*/
  fieldChange(e:any,type,field){
    if(type=='text' || type=='textarea'){
      this.updateField(field,e.target.value);
    }
    if(type=='branch' || type=='dropdown'){
      this.updateField(field,e.value);
    }
    if(type=='status'|| type=='file' || type=='dropdown'){
      this.updateField(field,e);
    }
  }
  updateField(field,value){
    if(this.updateValues.length>0){
      let filterUpdate=this.updateValues.filter((e)=>e.field!=field);
      let obj={field:field,value:value,};
      this.updateValues=[
        ...filterUpdate,
        obj,
      ]
    }
    else{
      let obj={field:field,value:value,};
      this.updateValues.push(obj);
    }
    // console.log(this.updateValues);
  }

  public checkError = (controlName: string, errorName: string) => {
    return this.usersForm.controls[controlName].hasError(errorName);
  }

  onSubmit() {
    this.formSubmit = true;
    // console.log(this.updateValues)
    if(this.usersForm.valid && this.updateValues && this.updateValues.length>0){

      // console.log('#################',this.usersForm)
    this.usersForm.value['isActive'] = +this.usersForm.value['isActive'];
      const obj = {
        userID: this.userID,
        fieldMap:this.userRestrictionData,
        // orgID: this.storage.get('userInfo').orgID,
        ...this.usersForm.value
      };
      this.updateValues.filter((e)=>{
        obj[e.field]=e.value;
      });

      
      // console.log(obj);
      obj['branch'] = this.selectedBranch;
    if(obj['userEmail']===this.mail) delete obj['userEmail'];

      this.api.transportManagerUserUpdate(obj).then((res: any) => {
        if (res.status == 'success') {
          this.swal.swalFunction(res.status, res.status, res.message, 2000);
          this.router.navigate(['/organization/transport-manager/information/orgInfo/users/view-users'])
        }
        if (res.status == 'failure') {
          this.swal.swalFunction('error', res.status, res.message, 3000);
        }
      }).catch((err) => {
        console.log(err);
      });

    }
  }

  _keyPress(event: any) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }
  
  showNestedData(id){
    let btn=document.getElementById(id);
    if(btn.classList.contains('fa-chevron-down')){
        btn.classList.replace('fa-chevron-down','fa-chevron-up');
    }else{
        btn.classList.replace('fa-chevron-up','fa-chevron-down');
    }
  }
  selectModule(event,value,moduleIndex){
    this.tableData[value].checked=event;
    this.tableData[value].indeterminate=false;
    if(this.tableData[value].menu1){
      let sub1=this.tableData[value].menu1;
      let subModules1=Object.keys(sub1);
      for(let i=0;i<subModules1.length;i++){
        sub1[subModules1[i]].checked=event;
        sub1[subModules1[i]].indeterminate=false;

        if(sub1[subModules1[i]].menu2){
          let sub2=sub1[subModules1[i]].menu2;
          let subModules2=Object.keys(sub2);
          for(let j=0;j<subModules2.length;j++){
            sub2[subModules2[j]].checked=event;
            sub2[subModules2[j]].indeterminate=false;

            if(sub2[subModules2[j]].menu3){
              let sub3=sub2[subModules2[j]].menu3;
              let subModules3=Object.keys(sub3);
              for(let k=0;k<subModules3.length;k++){
                sub3[subModules3[k]].checked=event;
                sub3[subModules3[k]].indeterminate=false;
              }
            }
          }
        }
      }
    }
  }
  selectSubmodule1(event,selectedModule,selectedSubmodule1,moduleIndex,subModule1Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=false;
    // this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!event;
    if(this.tableData[selectedModule].menu1[selectedSubmodule1].menu2){
      let sub2=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
      let subModules2=Object.keys(sub2);
      for(let i=0;i<subModules2.length;i++){
        sub2[subModules2[i]].checked=event;
        sub2[subModules2[i]].indeterminate=false;

        if(sub2[subModules2[i]].menu3){
          let sub3=sub2[subModules2[i]].menu3;
          let subModules3=Object.keys(sub3);
          for(let j=0;j<subModules3.length;j++){
            sub3[subModules3[j]].checked=event;
            sub3[subModules3[j]].indeterminate=false;
          }
        }
      }
    }
    this.checkModuleIndeterminateOrChecked(event,selectedModule);
  }
  checkModuleIndeterminateOrChecked(event,selectedModule){
    let sub1=this.tableData[selectedModule].menu1;
    let subModules1=Object.keys(sub1);
    let isValid=true;
    for(let i=0;i<subModules1.length;i++){
      if((sub1[subModules1[i]].checked==false || sub1[subModules1[i]].checked==undefined || sub1[subModules1[i]].indeterminate==false)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].checked=isValid;
      this.tableData[selectedModule].indeterminate=!isValid;
    }else{
      let checkArr=[];
      let indeterArr=[];
      for(let i=0;i<subModules1.length;i++){
        if(sub1[subModules1[i]].checked){
          checkArr.push('checked');
        }else if(sub1[subModules1[i]].indeterminate){
          indeterArr.push('indeterminate');
        }
      }
      if(checkArr.length<=0 && indeterArr.length<=0){
        this.tableData[selectedModule].indeterminate=isValid;
        this.tableData[selectedModule].checked=isValid;
      }else if(checkArr.length==subModules1.length){
        this.tableData[selectedModule].checked=!isValid;
        this.tableData[selectedModule].indeterminate=isValid;
      }else if(indeterArr.length==subModules1.length){
        this.tableData[selectedModule].indeterminate=!isValid;
        this.tableData[selectedModule].checked=isValid;
      }else{
        this.tableData[selectedModule].indeterminate=!isValid;
        this.tableData[selectedModule].checked=isValid;
      }
    }
  }
  selectSubmodule2(event,selectedModule,selectedSubmodule1,selectedSubmodule2,moduleIndex,subModule1Index,subModule2Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=false;
    if(this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3){
      let sub3=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
      let subModules3=Object.keys(sub3);
      for(let i=0;i<subModules3.length;i++){
        sub3[subModules3[i]].checked=event;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1);
  }
  checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1){
    let sub2=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2;
    let subModules2=Object.keys(sub2);
    let isValid=true;
    for(let i=0;i<subModules2.length;i++){
      if((sub2[subModules2[i]].checked==false || sub2[subModules2[i]].checked==undefined || sub2[subModules2[i]].indeterminate==false)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
    }else{
      let checkArr=[];
      let indeterArr=[];
      for(let i=0;i<subModules2.length;i++){
        if(sub2[subModules2[i]].checked){
          checkArr.push('checked');
        }else if(sub2[subModules2[i]].indeterminate){
          indeterArr.push('indeterminate');
        }
      }
      if(checkArr.length<=0 && indeterArr.length<=0){
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }else if(checkArr.length==subModules2.length){
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=isValid;
      }else if(indeterArr.length==subModules2.length){
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }else{
        this.tableData[selectedModule].menu1[selectedSubmodule1].indeterminate=!isValid;
        this.tableData[selectedModule].menu1[selectedSubmodule1].checked=isValid;
      }
    }
    this.checkModuleIndeterminateOrChecked(event,selectedModule);
  }
  selectSubmodule3(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3,moduleIndex,subModule1Index,subModule2Index,subModule3Index){
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].checked=event;
    this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3[selectedSubmodule3].indeterminate=false;
    this.checkSubmodule2IndeterminateOrChecked(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3)
  }

  checkSubmodule2IndeterminateOrChecked(event,selectedModule,selectedSubmodule1,selectedSubmodule2,selectedSubmodule3){
    let sub3=this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].menu3;
    let subModules3=Object.keys(sub3);
    let isValid=true;
    for(let i=0;i<subModules3.length;i++){
      if((!sub3[subModules3[i]].checked)){
        isValid=false;
        break;
      }else{
        isValid=true;
      }
    }
    if(isValid){
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=!isValid;
    }else{
      let arr=[];
      for(let i=0;i<subModules3.length;i++){
        arr.push(sub3[subModules3[i]].checked);
      }
      let value=arr.filter(e=>e==true);
      if(value.length<=0){
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=isValid;
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      }else{
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].indeterminate=!isValid;
          this.tableData[selectedModule].menu1[selectedSubmodule1].menu2[selectedSubmodule2].checked=isValid;
      }
    }
    this.checkSubmodule1IndeterminateOrChecked(event,selectedModule,selectedSubmodule1);
  }
  openPopup(){
    let modal=document.getElementById('userRestrictionModal');
    if(modal.classList.contains('hide')){
      modal.classList.replace('hide','show');
      modal.style.display='block';
    }
  }
  closePopup(){
    this.tableData=JSON.parse(JSON.stringify(this.userRestrictionData));
    this.closeClick();
  }
  closeClick(){
    let modal=document.getElementById('userRestrictionModal');
    if(modal.classList.contains('show')){
      modal.classList.replace('show','hide');
      modal.style.display='none';
    }
  }
  onModalSubmit(){
    let isValid=false;
    let keys=Object.keys(this.tableData);
    for(let i=0;i<keys.length;i++){
      if(this.tableData[keys[i]].checked || this.tableData[keys[i]].indeterminate){
        isValid=true;
        break;
      }else{
        isValid=false;
      }
    }
    if(isValid){
      this.userRestrictionData=JSON.parse(JSON.stringify(this.tableData));
      this.closeClick();
    }else{
      this.swal.swalFunction('error', 'Failure', 'You must select atleast one module!', 2000);
    }
  }
  
}
/* 
{
  "name": "shankar",
  "email": "shankar@groupten.com",
  "gender": "Male",
  "mobileNo": "9962020798",
  "userType": "Escort",
  "location": "Sutherland Global Services, Chennai, Tamil Nadu, India",
  "lat": 12.97865,
  "lng": 80.22015
} */












